module.exports = __webpack_public_path__ + "img/parking-space-free.9d75b276.svg";